import throttle from '../../plugins/throttle';

export default () => {

  if ($('.page-intro-nav').length) {

    $('html').on('click', '.page-intro-nav-mobile-toggle', (e) => {
      e.preventDefault();
      $(e.currentTarget).attr('data-open', $(e.currentTarget).attr('data-open') === 'true' ? 'false' : 'true').next().slideToggle(300);
    });

    $(window).on('resize', throttle(function() {
      if ($(window).width() > 899) {
        $('.page-intro-nav-mobile-toggle').attr('data-open', 'false');
      }
    }, 100));

  }

};
